/**
 * @namespace PAL
 * PAL HealthCare Command Bar functions
 */
jsPAL.cmdBar = new function()
{
	/**
	 * Table name for current workflow
	 */
	this.tableName = '';
	/**
	 * Selected record id for current workflow
	 */
	this.caseId = 0;
	/**
	 * assign back to user id
	 */
	this.assignBackUserId = 0;
	/**
	* contains information about the case that is being assigned
	*/
	this.assignCaseInfo = {};
	/**
	 * Automatically open case after assigning to the current user
	 */
	this.autoOpenCase = false;
	/**
	 * filter array to get latest case note or NULL if no note exists for the case
	 */
	this.caseNoteFilter = '<FilterBy Column="Id" FilterOperator="=" FilterValue="%CASEID%" Table="Case"/>' + '<MaxCount>1</MaxCount><Sort By="DownToCaseNoteByCaseId.Id" Order="Descending"/>';
	/**
	 * The currently command action, used by the operations queue to determine 
	 * if an action should be performed after save
	 */ 
	this.currentCommandAction = -1;
	/**
	* Prevent IE (of course) from processing command select change reentrantly
	*/
	this.processingCommand = false;
	/***** Command bar actions *****/

	 // use an array of actions so it can be dynamically created
	this.actions = [];

	/**
	 * Assign a case
	 */
	this.actions.actionAssignTo = 0;
	/**
	 * Request more work
	 */
	this.actions.actionRequestAdditionalWork = 1;
	/**
	 * Copy to your outgoing consult workflow
	 */
	this.actions.actionCopyForOutgoingConsult = 2;
	/**
	 * Request a consultation
	 */
	this.actions.actionSendConsultRequest = 3;
	/**
	 * Assign a case back
	 */
	this.actions.actionAssignBackToUser = 4;
	/**
	 * Assign to self
	 */
	this.actions.actionAssignToMe = 5;
	/**
	* Upload a case
	*/
	this.actions.actionUpload = 6;
	/**
	* Upload a case, for the nTh time
	*/
	this.actions.actionUploadAgain = 7;

	// count the number of actions
	var nrOfActions = 0;
	for (var action in this.actions) {
	  if (this.actions.hasOwnProperty(action)) nrOfActions++;
	}

	this.actionLast = nrOfActions-1;

	/***** End Command bar actions *****/

	/**
	 * Command bar actions text.  What appears in the command bar.
	 */ 	
	this.actionText = Array('Assign To', 
							'Request Additional Work', 
							'Copy for Outgoing Collaboration', 
							'Request Collaboration', 
							'Send Back to ', 
							'Assign Case to Me',
							'Upload to ePathAccess',
							'Update on ePathAccess');

	/**
	 *
	 */
	this.RemapActionTextByWorkflowName = function ()
	{
		switch (jsPAL.getPALModuleName())
		{
			case jsPAL.palModuleNames.AmnCaseAssemble :
							this.actionText[this.actions.actionAssignBackToUser] = 'Return';
							break;
			case jsPAL.palModuleNames.AmnConsultRequest :
							this.actionText[this.actions.actionRequestAdditionalWork] = 'Send Back';
							this.actionText[this.actions.actionAssignBackToUser] = 'Return to Collaborating Institution';
							break;
			case jsPAL.palModuleNames.AmnConsultAssign:
							this.actionText[this.actions.actionRequestAdditionalWork] = 'Obtain Information from Requesting Institution';
							this.actionText[this.actions.actionAssignBackToUser] = 'Return';
							break;
			case jsPAL.palModuleNames.AmnConsultReview :
							this.actionText[this.actions.actionRequestAdditionalWork] = 'Obtain Information from Requesting Institution';
							this.actionText[this.actions.actionAssignBackToUser] = 'Send Back';
							break;
		}
	}
	/**
	* 
	* flag indicating that inputs have been validated, and it is ok to do SaveAll
	* 
	*/
	this.inputsAreValid = true;
	/**
	* event is triggered by pal.js after a grid is loaded
	* @param event The event object
	*/
	$(document).bind('PALRepositionCommandBar', function(event) {
		jsPAL.cmdBar.reposition();
	});
	/**
	* event is triggered by jquery.vil.js after uScope is loaded
	* @param event The event object
	* @param parms Json object containing imageId and status (status true means image opened without error, false means error)
	*/
	$(document).bind('VILSYNC', function (event, parms)
	{
		jsPAL.cmdBar.reposition();
	});
	/**
	* event is triggered by operations.js after a delete
	* @param event The event object
	* @param eventData The event data
	*/
	$(document).bind('PALDeleteElement', function (event, eventData)
	{
		if (eventData.TableName === 'Case' && eventData.Ids == jsPAL.cmdBar.getCaseId())
			jsPAL.cmdBar.clearCmdBar();
	});
	/**
	* event is triggered by pal.js after a case tab is closed
	* @param event The event object
	& @param caseId The case Id
	*/
	$(document).bind('PALCaseTabClosed', function(event, caseId)
	{
		if (caseId == jsPAL.cmdBar.getCaseId())
			jsPAL.cmdBar.clearCmdBar();
	});
	$(window).scroll(function()
	{
		jsPAL.cmdBar.reposition();
	});
	/**
	 * Set the actions for a case
	 * @param actions An array of actions
	 * @param assignedUser The assigned user
	 */
	this.setActions = function(actions, assignedUser)
	{
		if (undefined === assignedUser || '' === assignedUser)
		{
			assignedUser = 'Assigned User';
		}
		// clear the existing actions		
		var select = this.clearActions();
		// actions is an array containing the action to set in the Command Bar select
		// add the actions in the actions array
		for ( var i = 0; i < actions.length; i++)
		{
			if ((actions[i] >= 0) && (actions[i] <= this.actionLast))
			{
				if (actions[i] == this.actions.actionAssignBackToUser)
				{
					// append assigned user name to the text
					select.append("<option value='" + actions[i] + "' >" + this.actionText[actions[i]] + assignedUser + "</option>");
				}
				else
				{
					select.append("<option value='" + actions[i] + "' >" + this.actionText[actions[i]] + "</option>");
				}
			}
		}
	};
	/**
	 * Clear all command actions
	 */
	this.clearActions = function()
	{
		var select = $('#commandBarActions');
		select.children().remove();
		// add an empty first option
		select.append("<option selected='selected' value='None'> </option>");
		return select;
	};
	/**
	 * Callback from the operations queue, indicating that a save has finished
	 * This includes the two passes for RFC and E-SIG, and only during the success case
	 */
	this.commandBarFinishedSavingEvent = function()
	{
		this.PerformCaseAction();
		this.currentCommandAction = -1;
	};
	/**
	 * Perform an action on the current case using the option set in <select> onChange Event
	*/
	this.PerformCaseAction = function()
	{
		if (this.currentCommandAction < 0 || this.processingCommand)
		{
			return;
		}
		this.processingCommand = true;
		switch (this.currentCommandAction)
		{
			case this.actions.actionAssignTo :
				this.doCheckDoAssignTo();
				break;
			case this.actions.actionRequestAdditionalWork :
				this.doRequestAdditionalWork();
				break;
			case this.actions.actionCopyForOutgoingConsult :
				this.doCopyForOutgoingConsult();
				break;
			case this.actions.actionSendConsultRequest :
				this.doSendConsultRequest();
				break;
			case this.actionCompleteCase :
				this.doCompleteCase();
				break;
			case this.actions.actionAssignBackToUser :
				this.doAssignBackToUser();
				break;
			case this.actions.actionAssignToMe :
				this.doAssignToMe();
				break;
			case this.actionCompleteConsult :
				this.doCompleteConsult();
				break;
			case this.actions.actionUpload:
				this.doUploadCase();
				break;
			case this.actions.actionUploadAgain:
				this.doUploadCaseAgain();
				break;
			default :
				break;
		}
		this.currentCommandAction = -1;
		this.processingCommand = false;
	};
	/**
	 * Function is called when the Command Bar select is changed
	 * @param commandBarActions The html select of the command bar
	 */
	this.selectChange = function(commandBarActions)
	{
		// set the currentCommandAction to an invalid value
		this.currentCommandAction = -1;
		this.selectedEndpointId = -1;
		// commandBarActions is the Actions select on the CommandBar
		var select = $(commandBarActions);
		this.currentCommandAction = select.find(":selected").val();
		if (typeof (this.currentCommandAction) === 'string')
		{
			this.selectedEndpointId = select.find(":selected").attr("endpointId");
			this.currentCommandAction = parseInt(this.currentCommandAction);
		}
		// if there are changes made anywhere then prompt the user to save the
		// changes first
		if (CheckDataUnsaved())
		{
			var dialogId = 'outstandingChangesDlg';
			// this function is called 3 times in IE8, don't display the dialog 3 times
			if ($('#' + dialogId).length > 0)
				return;
			create3ButtonModalConfirm("You have outstanding changes that haven\u2019t been saved.<br><br>Would you like to save them prior to performing the selected Action?",
			function()  // okFunction
			{
				// okay function
				// this needs to be a synchronous operation
				// the callback from the operations queue will be
				// commandBarFinishedSavingEvent()
				CommandBarSaveAll();
			}, "Yes",
			function()  // noFunction
			{
				// no function
				jsPAL.cmdBar.PerformCaseAction();
			}, "No",
			function()  // cancelFunction
			{
				// cancel function (does nothing)
			}, "Cancel", "Confirm Action",
			dialogId);
		}
		else
		{
			// if endpoint is defined in the dropdown it means that it's a transfer case
			if (typeof this.selectedEndpointId !== 'undefined' && this.selectedEndpointId >= 0)
			{
				if (this.currentCommandAction < 0 || this.processingCommand)
				{
					return;
				}
				this.processingCommand = true;
				this.transferTo(this.selectedEndpointId);
				this.currentCommandAction = -1;
				this.processingCommand = false;
			}
			else
			{
				// you can still bail on the action by pressing the cancel on the
				// action dialog
				this.PerformCaseAction();
			}

		}
		// reset the command bar combo box to the empty item
		select.get(0)[0].selected = true;
	};
	/**
	 * Function is called when a new row is selected in a jqGrid
	 * @param recordId The primary key from the case table
	 * @param status unused
	 */
	this.gridRowSelected = function(recordId, status)
	{
		jsPAL.cmdBar.setActionsForCaseGrid(recordId);
	};
	/**
	 * The current sql table name for the selected row
	 * @returns Sql table name
	 */
	this.getTableName = function()
	{
		return this.tableName;
	};
	/**
	 * Set current sql table name for the selected row
	 * @param tableName The sql table name
	 */	
	this.putTableName = function(tableName)
	{
		this.tableName = tableName;
	};
	/**
	 * Get the currently select case id
	 * @return The case id
	 */		
	this.getCaseId = function()
	{
		return this.caseId;
	};
	/**
	* Get the currently select consultation request id for the current case
	* @return The consultation request id, or -1 if no request has been made
	*/
	this.getConsultationRequestId = function ()
	{
		var selectedRow = jsPAL.getCaseGridRow(this.caseId);
		if (selectedRow)
		{
			// get consultation request id for the currently select grid row
			return  selectedRow.attr('downtovwcaseconsultrequestcurrentbycaseid.consultrequestid');
		}
		return -1;
	};
	/**
	 * Set the current case id
	 * @param recordId The record primary key	 
	 */			
	this.putCaseId = function(recordId)
	{
		this.caseId = recordId;
	};
	/**
	 * Clear the currently selected case, current action and the case actions select
	 */	
	this.clearCmdBar = function()
	{
		jsPAL.cmdBar.caseId = 0;
		jsPAL.cmdBar.clearCurrentAction();
		jsPAL.cmdBar.clearActions();
	};
	/**
	 * Get the Case Note for the current case
	 * @returns String encoded Case Note
	 */
	this.getCaseNoteFilter = function()
	{
		return encodeURIComponent(this.caseNoteFilter.replace('%CASEID%', this.caseId));
	};
	/**
	 * For AllRecords and CaseAssembly workflows, check if case is already
	 * assigned before calling doAssignTo.
	 * If case is already assigned, prompt user to see if they really want to assign it another user
	 */
	this.doCheckDoAssignTo = function()
	{
		var workflow = jsPAL.getPALModuleName();
		var userName = "";
		if (workflow === 'AllRecords' || workflow === 'CaseAssembly')
		{
			// find the jqGrid row for this case id
			var selectedRow = jsPAL.getCaseGridRow(this.caseId);
			// get userId that the case is currently assigned to
			var userId = selectedRow.attr('assigneduserid');
			if (undefined !== userId && '' !== userId)
			{
				// get username that the case is assigned to
				if (SystemParms.UserId === userId)
				{
					userName = "You";
				}
				else
				{
					var userName = selectedRow.attr('downtovwcaseinfobycaseid.assignedto');
					if (undefined === userName || '' === userName)
					{
						userName = "Another User";
					}
				}
				createModalConfirm("<br>Do you want to assign this case to a different user?", function()
				{
					// "Yes" function
					jsPAL.cmdBar.doAssignTo();
				}, "Yes", function()
				{
					// "No" function
					return;
				}, "No", "This Case is Assigned to " + userName);
			}
			else
			{
				// case is not currently assigned to a user, go ahead and assign
				// it
				jsPAL.cmdBar.doAssignTo();
			}
		}
		else
		{
			// not AllRecords or CaseAssembly, go ahead and assign it
			jsPAL.cmdBar.doAssignTo();
		}
	};
	/**
	 * Perform a item assignment
	 */	
	this.doAssignTo = function()
	{
		if (this.caseId !== 0)
		{
			this.createAssignToDlg();
			var dlg = $("#assignToDlg");
			jsPAL.displayNotification("Reading Case Data. Please wait...", 0);
			Ajax(
			{
				// get the case note field for the case and put it in the dialog
				type : "POST",
				url : "/AJAXDatabaseRead.php",
				data : "Method=GetFilteredRecordListWithFilterArray&TableName=Case&Columns=Id,DownToCaseNoteByCaseId.NoteText,InIOCAssembly,DataGroupId&FilterArray=" + this.getCaseNoteFilter(),
				success : function(msg)
				{
					jsPAL.closeNotification();
					var response = ParseJson(msg);
					// load the memo data (if any) into the dialog
					if (response == null)
					{
						return;
					}
					jsPAL.cmdBar.assignCaseInfo = response[0];
					if (undefined !== response[0]['DownToCaseNoteByCaseId.NoteText'])
					{
						var memo = response[0]['DownToCaseNoteByCaseId.NoteText'];
						if (memo.length > 0)
						{
							memo += '\n';
						}
						dlg.find('#assignCaseNote').val(memo);
					}

					// load the users and user groups into the dialog select.
					// If case is IOC, then load users that have access to the IntraOperative workflow,
					// else load users that have access to the DigitalReview workflow
					Ajax(
					{
						type : "GET",
						url : "/PALModules/HealthCare/GetWorkflowUsersAndGroups.php",
						data : "WorkflowName=" + ((undefined !== response[0].InIOCAssembly && (response[0].InIOCAssembly == '1')) ? 'IntraOperative' : 'DigitalReview') + "&DataGroupId="+response[0].DataGroupId,
						success : function(msg)
						{
							response = ParseJson(msg);
							if (response == null)
								return;
							var select = dlg.find('#assignToUserSelect');
							select.children().remove();
							select.append("<optgroup label='Users:' class='optgroup'>");
							for ( var i = 0; i < response.Users.length; i++)
							{
								var userName = response.Users[i].FullName;
								if (userName === '')
								{
									userName = response.Users[i].LoginName;
								}
								select.append("<option class='option' value='User:" + response.Users[i].Id + "'>" + userName + "</option>");
							}
							select.append("<optgroup label='User Groups:' class='optgroup'>");
							for (i = 0; i < response.UserGroups.length; i++)
							{
								select.append("<option class='option' value='UserGroup:" + response.UserGroups[i].Id + "'>" + response.UserGroups[i].Name + "</option>");
							}
							if (response.Users.length > 0 || response.UserGroups.length > 0)
							{
								dlg.find('#assignToUserSelect').get(0)[0].selected = true;
								dlg.dialog('open');
							}
							else
							{
								alert('There are no users or user groups that this case can be assigned to.\nPlease verify that this case is in a datagroup that users have access to.');
								jsPAL.closeNotification();
							}
						},
						error : function(jqXHR, textStatus, errorThrown)
						{
						}
					});
				},
				error : function(jqXHR, textStatus, errorThrown)
				{
					alert("Error Assigning Case to User: " + errorThrown);
				}
			});
		}
		else
		{
			alert('You must first select a case to assign');
		}
	};
	/**
	 * Assign the current case back to the user
	 */
	this.doAssignBackToUser = function()
	{
		if (this.caseId !== 0)
		{
			// find the jqGrid row for this case id
			var selectedRow = jsPAL.getCaseGridRow(this.caseId);
			this.assignBackUserId = selectedRow.attr('assigneduserid');
			this.createAssignBackDlg();
			var dlg = $("#assignBackDlg");
			jsPAL.displayNotification("Reading Case Data. Please wait...", 0);
			Ajax(
			{
				// get the memo field from the case and put it in the dialog
				type : "POST",
				url : "/AJAXDatabaseRead.php",
				data : "Method=GetFilteredRecordListWithFilterArray&TableName=Case&Columns=Id,DownToCaseNoteByCaseId.NoteText,InIOCAssembly&FilterArray=" + this.getCaseNoteFilter(),
				success : function(msg)
				{
					var response = ParseJson(msg);
					if (response == null)
						return;
					if (undefined !== response.Alert)
					{
						jsPAL.closeNotification();
						if (response.Alert.indexOf(-7014) > -1)
						{
							alert('Unable to assign case - a database error has occurred.')	
						}
						else
						{
							alert(response.Alert);
						}
						return;
					}
					// load the memo data (if any) into the dialog
					if (undefined !== response[0]['DownToCaseNoteByCaseId.NoteText'])
					{
						var memo = response[0]['DownToCaseNoteByCaseId.NoteText'];
						if (memo.length > 0)
						{
							memo += '\n';
						}
						dlg.find('#assignBackCaseNote').val(memo);
					}
					// assign to user
					jsPAL.displayNotification("Assigning Case. Please wait...");
					dlg.dialog('open');
				},
				error : function(jqXHR, textStatus, errorThrown)
				{
				}
			});
		}
	};
	/**
	 * assign a case to me. if openCase is true, then the case is automatically
	 * opened after being assigned to me.
	 * @param openCase True/False If true, open the case after assigning
	 */
	this.doAssignToMe = function(openCase)
	{
		if (this.caseId !== 0)
		{
			if (undefined !== openCase && openCase === true)
			{
				jsPAL.cmdBar.autoOpenCase = true;
			}
			Ajax(
			{
				type : "POST",
				url : "/PALModules/HealthCare/AssignCase.php",
				data : "updatecasememo=0&caseid=" + jsPAL.cmdBar.caseId + "&userid=" + SystemParms.UserId,
				success : function(msg)
				{
					var response = ParseJson(msg);
					if (response == null)
						return;
					if (response.ASResult != '0')
					{
						alert(response.ASMessage);
					}
					else
					{
						jsPAL.updateBadgeData();
						if (jsPAL.cmdBar.autoOpenCase)
						{
							jsPAL.cmdBar.autoOpenCase = false;
							var filter = "Worklist";
							var select = $('#gridSelect');
							if (select.length > 0)
							{
								// get the grid filter select text
								filter = select.find(":selected").html();
								// Note, we have inconsistently named grid views. All filters except for Worklist have the
								// word Cases appended to the filter text.
								//
								// For Worklist, the grid is named like:
								//   GridDigitalReview_Worklist_Grid_Case
								// But for Pending, Completed and All, the grid is named like:
								//   GridDigitalReview_PendingCases_Grid_Case
								//   GridDigitalReview_CompletedCases_Grid_Case
								//   GridDigitalReview_AllCases_Grid_Case
								if (filter !== 'Worklist')
									filter += 'Cases';
							}
							$(document).bind('PALGridLoadCompleteEvent', function(event, grid)
							{
								// make sure this is the grid for the current workflow and selected filter
								var gridName = 'Grid' + jsPAL.getPALModuleName() + '_' + filter + '_Grid_Case';
								if ($(grid).attr('id').substr(0, gridName.length) === gridName)
								{
									// find the grid <tr> for this case
									var tr = $(grid).find('tr[id=' + jsPAL.cmdBar.caseId + ']');
									if (tr.length > 0)
									{
										setTimeout(function(){											
											// found the <tr>, find the action icon to view the
											// case, and click it if found
											var action = tr.find("a.View");
											if (action.length > 0)
											{
												action.click();
											}
										}, 500);
										jsPAL.cmdBar.caseId = 0;
										$(document).unbind('PALGridLoadCompleteEvent');
									}
								}
							});
						}
						else
						{
							jsPAL.cmdBar.caseId = 0;
						}
					}
					// refresh visible grids, will trigger the
					// PALGridLoadCompleteEvent bound function above
					jsPAL.refreshJQGrids();
					jsPAL.cmdBar.assignBackUserId = 0;
				},
				error : function(jqXHR, textStatus, errorThrown)
				{
					alert("Error Assigning Case to User: " + errorThrown);
					jsPAL.updateBadgeData();
				}
			});
		}
	};
	/**
	 * Request additional work
	 */
	this.doRequestAdditionalWork = function()
	{
		if (this.caseId !== 0)
		{
			this.createSendBackToCaseAssemblyDlg();
			var dlg = $("#sendBackToCaseAssemblyDlg");
			// get the memo field from the case and put it in the dialog
			jsPAL.displayNotification("Reading Case Data. Please wait...", 0);
			Ajax(
			{
				type : "POST",
				url : "/AJAXDatabaseRead.php",
				data : "Method=GetFilteredRecordListWithFilterArray&TableName=Case&Columns=DownToCaseNoteByCaseId.NoteText,InIOCAssembly&FilterArray=" + this.getCaseNoteFilter(),
				success : function(msg)
				{
					var response = ParseJson(msg);
					if (response == null)
						return;
					if (undefined !== response.Alert)
					{
						jsPAL.closeNotification();
						if (response.Alert.indexOf(-7014) > -1)
						{
							alert('Unable to request additional work - a database error has occurred.')	
						}
						else
						{
							alert(response.Alert);
						}
						return;
					}
					// load the memo data (if any) into the dialog
					if (undefined !== response[0]['DownToCaseNoteByCaseId.NoteText'])
					{
						var memo = response[0]['DownToCaseNoteByCaseId.NoteText'];
						if (memo.length > 0)
						{
							memo += '\n';
						}
						dlg.find('#sendBackToCaseAssemblyCaseNote').val(memo);
					}
					dlg.dialog('open');
				},
				error : function(jqXHR, textStatus, errorThrown)
				{
					alert("Error Sending Case Back to Case Assembly: " + errorThrown);
				}
			});
		}
		else
		{
			alert('You must first select a case to send back');
		}
	};
	/**
	 * Send a consultation request for the current case
	 */	
	this.doSendConsultRequest = function()
	{
		this.createSendConsultReqDlg();
		if (this.caseId !== 0)
		{
			var dlg = $("#consultRequestDlg");
			// Add all users that are a members of the Pathologists groups
			// (UserGroupFunction Id = '1')
			// exclude the currently logged on user
			Ajax(
			{
				type : "GET",
				url : "/PALModules/HealthCare/GetWorkflowUsersAndGroups.php",
				data : "WorkflowName=ConsultationReview",
				success : function(msg)
				{
					var response = ParseJson(msg);
					if (response == null)
						return;
					var select = dlg.find('#consultReqUserSelect');
					select.children().remove();
					select.append("<optgroup label='Internal Collaboration:' class='optgroup'>");
					for ( var i = 0; i < response.Users.length; i++)
					{
						// can't request consult for yourself
						if (response.Users[i].Id != SystemParms.UserId)
						{
							var userName = response.Users[i].FullName;
							if (userName === '')
							{
								userName = response.Users[i].LoginName;
							}
							select.append("<option class='option' value='User:" + response.Users[i].Id + "'>" + userName + "</option>");
						}
					}
					if (dlg.find('option').length > 0)
					{
						dlg.find('#consultReqUserSelect').get(0)[0].selected = true;
						dlg.dialog('open');
					}
					else
					{
						alert('Cannot send collaboration request.\nThere are no users to collaborate with');
					}
				},
				error : function(jqXHR, textStatus, errorThrown)
				{
				}
			});
		}
		else
		{
			alert('You must first select a case for collaboration');
		}
	};
	/**
	 * Copy the current case for outgoing consult
	 */		
	this.doCopyForOutgoingConsult = function()
	{
		if (this.caseId !== 0)
		{
			jsPAL.viewer.saveDst(this.caseId);
			jsPAL.createConsultationRequest(this.getCaseId());
		}
		else
		{
			alert('You must first select a case for collaboration');
		}
	};
	/**
	 * Complete the current case
	 */			
	this.doCompleteCase = function()
	{
		if (this.caseId !== 0)
		{
			jsPAL.completeCase(this.getCaseId());
		}
		else
		{
			alert('You must first select a case to complete');
		}
	};
	/**
	 * Complete the current case consultation
	 */			
	this.doCompleteConsult = function()
	{
		if (this.caseId !== 0)
		{
			jsPAL.completeCaseReview(this.getCaseId());
		}
		else
		{
			alert('You must first select a case to complete');
		}
	};
	/**
	 * Upload a case to the cloud
	 */
	this.doUploadCase = function()
	{
		return this.UploadCase("upload");
	};
	/**
	 * Update a case to the cloud
	 **/
	this.doUploadCaseAgain = function()
	{
		return this.UploadCase("update");
	};
	this.UploadCase = function(uploadMode)
	{
		uploadMode = (typeof uploadMode !== 'undefined') ? uploadMode : "upload";

		if (this.caseId)
		{
			var caseId = this.caseId;
			var notificationTxt = "Reading case data. Please wait...";
			var displayPreviousMemos = true;
			var dialogId = "#uploadCaseRequestDlg";
			var errorMsg = "Error scheduling case for " + uploadMode + ": ";
			var dataUri = "Method=GetFilteredRecordListWithFilterArray&TableName=Case&Columns=Id,DownToCaseNoteByCaseId.NoteText&FilterArray=" + this.getCaseNoteFilter();
			$.ajax(
			{
				type: "POST",
				url: "/PALModules/Healthcare/GetCaseUploadStatus.php",
				data: "caseid=" + caseId,
				success: function (msg)
				{
					var caseStatus = '';
					var jsonData = ParseJson(msg);
					if (jsonData.hasOwnProperty('StatusId'))
					{
						caseStatus = jsonData['StatusId'];
					}
					else
					{
						caseStatus = "";
					}

					if ( caseStatus != "1" && caseStatus != "2" && caseStatus != "4")
					{

						jsPAL.cmdBar.createUploadCaseRequestDlg(uploadMode);
						jsPAL.cmdBar.loadGenericMemoPromptDialog(dialogId, dataUri, notificationTxt, errorMsg, displayPreviousMemos); // create and open the dialog
					}
					else
					{
						//eCase already scheduled for Upload
						alert("eCase already scheduled for " + uploadMode);
					}

				},
				error: function (jqXHR, textStatus, errorThrown)
				{
					alert("Error retrieving case " + uploadMode + " status: " + errorThrown);
				}
			});
		}
		else
		{
			alert("You must first select a case to upload");
		}
		return false;
	};
	/**
	 * Transfer case to Endpoint
	 **/
	this.transferTo = function(endpointId)
	{
		var confirmation = confirm("Are you sure you want to transfer the case?");
		if (confirmation == true)
		{
			var caseId = jsPAL.cmdBar.getCaseId();
			var postData =  { caseid: caseId, endpointId: endpointId }
			const FILE_TRANSFER_SUCCESS = 1;

			$.ajax(
			{
				type : "POST",
				url : "/PALModules/HealthCare/CaseAssembly/TSTransferCase.php",
				data: postData,
				success : function(response)
				{
					// check if response is in the correct format
					if (typeof response == 'object' && $(response).length > 0)
					{
						var transferKey = Object.keys(response).shift(); // get the first item from the response keys
						var transferMessage = Object.values(response).shift(); // get the first item from the response values

						// if response key from the ajax request is 1 then display success message
						if (transferKey == FILE_TRANSFER_SUCCESS){
							jsPAL.cmdBar.commandComplete(true);
							jsPAL.displayNotification("Case successfully submitted for transfer.");	
						}
						// otherwise display error message
						else
						{
							if (transferMessage == "null" || transferMessage == null){
								transferMessage = "Transfer Services is not configured properly."
							}
							transferServicesErrorMessage(transferMessage);
						}
					}
					// otherwise display error message
					else
					{
						transferMessage = "Transfer Services is not configured properly."
						transferServicesErrorMessage(transferMessage);
					}
				},
				error : function(jqXHR, textStatus, errorThrown)
				{
					transferServicesErrorMessage(errorThrown);
				}
			});
		}
	};
	/**
	 * Create an assignment modal dialog
	 */					
	this.createAssignToDlg = function()
	{
		if ($('#assignToDlg').find().length === 0)
		{
			$('#assignToDlg').dialog(
			{
				autoOpen : false,
				title : 'Assign Case to User or User Group',
				modal : true,
				resizable : false,
				width : "660px",
				closeOnEscape : false,
				open : function(event, ui)
				{
					$(".ui-dialog-titlebar-close").hide();
					$('#assignCaseNote').focus();
				},
				buttons :
				{
					"Assign" : function()
					{
						// table:id, e.g. User:10
						var assignToVal = $('#assignToUserSelect').find(":selected").val();
						if (undefined === assignToVal || assignToVal === '')
						{
							alert('Please select a user or group to assign the case to');
						}
						else
						{
							// sanity check, the command bar should be holding
							// Case data
							if (jsPAL.cmdBar.getTableName() != 'Case')
							{
								// Probably need to trigger a Spectrum error for
								// this
								alert('Internal Error - command bar tablename is ' + jsPAL.cmdBar.getTableName() + ' it was expected to be "case"');
								$(this).dialog("close");
								return;
							}

							// assignToInfo[0] is table to assign the case to (Users or UserGroup)
							// assignToInfo[1] is record id for the user or user group
							// caseId is the record id of the case that is being assigned
							var assignToInfo = assignToVal.split(':');
							var caseId = jsPAL.cmdBar.getCaseId();
							var assignTarget;
							var assignId;
							if (assignToInfo[0] == 'User')
							{
								assignTarget = "User";
								assignId = "userid";
							}
							else if (assignToInfo[0] === 'UserGroup')
							{
								assignTarget = "User Group";
								assignId = "usergroupid";
							}
							else
							{
								return;
							}

							// assign to user or group
							jsPAL.displayNotification("Assigning Case. Please wait...");
							Ajax(
							{
								type : "POST",
								url : "/PALModules/HealthCare/AssignCase.php",
								data : "updatecasememo=1&caseid=" + caseId + "&" + assignId + "=" + assignToInfo[1] + "&memocontent=" + encodeURIComponent($('#assignCaseNote').val()),
								success : function(msg)
								{
									$('#assignCaseNote').val("");
									var response = ParseJson(msg);
									if (response == null)
										return;
									if (response.ASResult == '0')
									{
										// don't close the case tab if this is an IOC case
										jsPAL.cmdBar.commandComplete(jsPAL.cmdBar.assignCaseInfo.InIOCAssembly != 1);
										jsPAL.displayNotification("Case Assigned to " + assignTarget);
										// addNewCaseTab is in CaseAssembly workflow
										if (typeof (addNewCaseTab) === 'function')
										{
											addNewCaseTab($('#MainTabs'));
										}
									}
									else
									{
										alert(response.ASMessage);
									}
								},
								error : function(jqXHR, textStatus, errorThrown)
								{
									alert("Error Assigning Case to " + assignTarget + ": " + errorThrown);
									jsPAL.updateBadgeData();
								}
							});
							$(this).dialog("close");
						}
					},
					Cancel : function()
					{
						jsPAL.closeNotification();
						$(this).dialog("close");
					}
				}
			});
		}
	};
	/**
	 * Create an assignment modal dialog for assigning a case back to the originator
	 */	
	this.createAssignBackDlg = function()
	{
		if ($('#assignBackDlg').find().length === 0)
		{
			$('#assignBackDlg').dialog(
			{
				autoOpen : false,
				title : 'Assign Case Back to User',
				modal : true,
				resizable : false,
				width : 400,
				closeOnEscape : false,
				open : function(event, ui)
				{
					$(".ui-dialog-titlebar-close").hide();
					$('#assignBackCaseNote').focus();
				},
				buttons :
				{
					"Assign" : function()
					{
						// sanity check, the command bar should be holding Case
						// data
						if (jsPAL.cmdBar.getTableName() != 'Case')
						{
							// Probably need to trigger a Spectrum error for
							// this
							alert('Internal Error - command bar tablename is ' + jsPAL.cmdBar.getTableName() + ' it was expected to be "case"');
							$(this).dialog("close");
							return;
						}
						Ajax(
						{
							type : "POST",
							url : "/PALModules/HealthCare/AssignCase.php",
							data : "updatecasememo=1&caseid=" + jsPAL.cmdBar.caseId + "&userid=" + jsPAL.cmdBar.assignBackUserId + "&memocontent=" + encodeURIComponent($('#assignBackCaseNote').val()),
							success : function(msg)
							{
								var response = ParseJson(msg);
								if (response == null)
									return;
								$('#assignBackCaseNote').val("");
								if (response.ASResult == '0')
								{
									jsPAL.cmdBar.commandComplete(true);
									jsPAL.displayNotification("Case Assigned to User");
								}
								else
								{
									alert(response.ASMessage);
								}
								jsPAL.cmdBar.assignBackUserId = 0;
							},
							error : function(jqXHR, textStatus, errorThrown)
							{
								alert("Error Assigning Case to User: " + errorThrown);
								jsPAL.updateBadgeData();
							}
						});
						$(this).dialog("close");
					},
					Cancel : function()
					{
						jsPAL.closeNotification();
						$(this).dialog("close");
					}
				}
			});
		}
	};
	/**
	 * Create an consultation request dialog
	 */			
	this.createSendConsultReqDlg = function()
	{
		if ($('#consultRequestDlg').find().length === 0)
		{
			$('#consultRequestDlg').dialog(
			{
				autoOpen : false,
				title : 'Send Case Collaboration',
				modal : true,
				resizable : false,
				width : 400,
				closeOnEscape : false,
				open : function(event, ui)
				{
					$(".ui-dialog-titlebar-close").hide();
				},
				buttons :
				{
					"Request Collaboration" : function()
					{
						// table:id, e.g. User:10
						var assignToVal = $('#consultReqUserSelect').find(":selected").val();
						if (undefined === assignToVal || assignToVal === '')
						{
							alert('Please select a user to send collaboration request to');
						}
						else
						{
							// sanity check, the command bar should be holding
							// Case data
							// var assignToInfo = assignToVal.split(':');
							if (jsPAL.cmdBar.getTableName() != 'Case')
							{
								// Probably need to trigger a Spectrum error for
								// this
								alert('Internal Error - command bar tablename is ' + jsPAL.cmdBar.getTableName() + ' it was expected to be "Case"');
								$(this).dialog("close");
								return;
							}

							// assignToInfo[0] is table to assign the case to
							// (Users or UserGroup)
							// assignToInfo[1] is record id for the user or user
							// group
							// caseId is the record id of the case that is being
							// assigned
							var assignToInfo = assignToVal.split(':');
							var caseId = jsPAL.cmdBar.getCaseId();
							jsPAL.viewer.saveDst(caseId);
							// assign to user
							Ajax(
							{
								type : "POST",
								url : "/PALModules/HealthCare/CreateCaseConsultationReview.php",
								data : "caseid=" + caseId + "&userid=" + assignToInfo[1],
								success : function(msg)
								{
									$('#consultRequestMemo').val("");
									var response = ParseJson(msg);
									if (response == null)
										return;
									if (response.ASResult == '0')
									{
										jsPAL.displayNotification("Collaboration Request Sent");
										jsPAL.refreshJQGrids();
									}
									else
									{
										alert(response.ASMessage);
									}
								},
								error : function(jqXHR, textStatus, errorThrown)
								{
									alert("Error Sending Collaboration Request: " + errorThrown);
									jsPAL.updateBadgeData();
								}
							});
						}

						$(this).dialog("close");
					},
					Cancel : function()
					{
						jsPAL.closeNotification();
						$(this).dialog("close");
					}
				}
			});
		}
	};
	/**
	 * Create an send back to case assembly modal dialog
	 */				
	this.createSendBackToCaseAssemblyDlg = function()
	{
		if ($('#sendBackToCaseAssemblyDlg').find().length === 0)
		{
			$('#sendBackToCaseAssemblyDlg').dialog(
			{
				autoOpen : false,
				title : 'Send Case Back to Case Assembly',
				modal : true,
				resizable : false,
				width : 400,
				closeOnEscape : false,
				open : function(event, ui)
				{
					$(".ui-dialog-titlebar-close").hide();
					$('#sendBackToCaseAssemblyCaseNote').focus();
				},
				buttons :
				{
					"Send" : function()
					{
						jsPAL.displayNotification("Sending Case Back. Please wait...");
						var caseId = jsPAL.cmdBar.getCaseId();
						Ajax(
						{
							type : "POST",
							url : "/PALModules/HealthCare/RequestMoreWork.php",
							data : "caseid=" + caseId + "&memocontent=" + encodeURIComponent($('#sendBackToCaseAssemblyCaseNote').val()),
							success : function(msg)
							{
								$('#sendBackToCaseAssemblyCaseNote').val("");
								var response = ParseJson(msg);
								if (response == null)
									return;
								if (response.ASResult == '0')
								{
									jsPAL.cmdBar.commandComplete(true);
									jsPAL.displayNotification("Case Sent Back to Case Assembly");
								}
								else
								{
									alert(response.ASMessage);
								}
							},
							error : function(jqXHR, textStatus, errorThrown)
							{
								alert("Error Sending Case to Case Assembly: " + errorThrown);
								jsPAL.updateBadgeData();
								jsPAL.refreshJQGrids();
							}
						});
						$(this).dialog("close");

					},
					Cancel : function()
					{
						jsPAL.closeNotification();
						$(this).dialog("close");
					}
				}
			});
		}
	};
	/**
	 * Function to reposition the command bar as a 'sticky floating footer'
	 */				
	this.reposition = function()
	{
		if ('undefined' !== typeof SystemParms)
		{
			// disable the command bar buttons if running on an iOS device
			// and workflow is CaseAssembly or one of the Admin workflows
			if (undefined !== SystemParms.isiDevice && SystemParms.isiDevice)
			{
				var workflowName = jsPAL.getPALModuleName();
				var disableButtons = (workflowName === 'CaseAssembly' || SystemParms.AdminMode === true);
				EnableDisableHCCommmadBarButtons(disableButtons, false);
			}
		}
		var cmdBar = $('#CommandBarHC');
		var cmdBarHeight = cmdBar.height();
		cmdBar.hide();
		var windowHeight = $(window).height();
		var windowWidth = $(window).width();
		var documentHeight = $(document.body).height();
		cmdBar.show();
		if (documentHeight + cmdBarHeight > windowHeight)
		{
			var PALNavWidth = $('#PALNav').width() + parseInt($('#PALNav').css('margin-left')) + parseInt($('#PALNav').css('margin-right'));
			var cmdBarWidth = Math.max(windowWidth - PALNavWidth - 20 , 520);
			cmdBar.css(
			{
				position : "fixed",
				width : cmdBarWidth,
				bottom: 0
			}).addClass('CommandBarHCBorder');
		}
		else
		{
			cmdBar.css(
			{
				position : "static",
				width : "auto"
			}).removeClass('CommandBarHCBorder');
		}
	};
	/**
	 * Get an array of actions from a given object
	 * @param obj Either a JQGrid row or the AlreadyOpenedCases Global for the current case
	 */
	this.getActionArray = function (obj)
	{
		var actions = Array();

		this.RemapActionTextByWorkflowName();

		for (var shRecordKey in jsPAL.shRecordStateColumns)
		{
			var recordStateColumn = jsPAL.shRecordStateColumns[shRecordKey];
			//if the JQgrid row has the 'CanXXX' attribute
			//and the attribute is marked as true
			var attributeVal;
			if (typeof obj.attr === 'function')
			{
				attributeVal = obj.attr(recordStateColumn.attr.toString());
			}
			else
			{
				attributeVal = obj[recordStateColumn.attr.toString()];
			}
			if ('true' == attributeVal)
			{
				//if the sh record state has a action associated with it
				if (recordStateColumn.hasOwnProperty('actionIndex'))
				{
					//push the action into the array
					//this will end up being displayed in the drop down
					actions.push(recordStateColumn['actionIndex']);
				}
			}
		}

		return jsPAL.cmdBar.getCustomActionMappingRules(obj, actions);
	};
	/**
	 * If the action state 'CanAssign' is in the current set of actions
	 * AND the workflow is Digital Review or IntraOperative
	 * AND the case is assigned to a UserGroup
	 * THEN change the 'Assign To' action to 'Assign To Me'
	 * If the action state 'CanRequestAw' is in the current set of actions
	 * AND the workflow is AmnConsultReview (CP)
	 * THEN create an additional action to Send Back to CD (the regular one sends back to RP)
	 * @param obj Either a JQGrid row or the AlreadyOpenedCases Global for the current case
	 * @param actions The array of command bar actions
	 */
	this.getCustomActionMappingRules = function (obj, actions)
	{
		var workFlowName = jsPAL.getPALModuleName();

		var attributeValCanAssign;
		var attributeValCanRequestAw;
		if (typeof obj.attr === 'function')
		{
			attributeValCanAssign = obj.attr(jsPAL.shRecordStateColumns.CanAssign.attr);
			attributeValCanRequestAw = obj.attr(jsPAL.shRecordStateColumns.CanRequestAw.attr);
		}
		else
		{
			attributeValCanAssign = obj[jsPAL.shRecordStateColumns.CanAssign.attr];
			attributeValCanRequestAw = obj[jsPAL.shRecordStateColumns.CanRequestAw.attr];
		}
		if ('true' == attributeValCanAssign)
		{
			// for these workflows, if the case is assigned to a user group,
			// then use the
			// actionAssignToMe action rather than the actionAssignTo action
			if ((jsPAL.palModuleNames.DigitalReview === workFlowName) || (jsPAL.palModuleNames.IntraOperative === workFlowName))
			{
				var assignedGroup;
				if (typeof obj.attr === 'function')
				{
					assignedGroup = obj.attr(jsPAL.workflowSharedColumns.AssignedUserGroupId.attr);
				}
				else
				{
					assignedGroup = obj[jsPAL.workflowSharedColumns.AssignedUserGroupId.attr];
				}
				if (undefined !== assignedGroup && '' !== assignedGroup)
				{
					//if the action 'assign to' is in the current list
					// and the the item is assigned to a user group
					//then we want to remove 'assign to' and add assign to me
					var index = $.inArray(jsPAL.cmdBar.actions.actionAssignTo, actions);
					if (index >= 0)
					{
					   actions.splice(index, 1);
					}
					else
					{
						index = 0;
					}
					//if assign to me is not already in the actions array then add it
					var indexAssignToMe = $.inArray(jsPAL.cmdBar.actions.actionAssignToMe, actions);
					if (indexAssignToMe < 0)
					{
						actions.splice(index, 0, jsPAL.cmdBar.actions.actionAssignToMe);
					}
				}
			}
		}
		if (('true' == attributeValCanRequestAw) && (jsPAL.palModuleNames.AmnConsultReview === workFlowName))
		{
			// for this AmnConsultReview when Request Additional Work Needed is possible, need two actions :
			//     one for 'actionRequestAdditionalWork' for more information from the requesting site (RP) -- added prior 
			//     one for 'actionSendBackToDispatcher' for returning to consulting dispatcher (CD) -- add here
			actions.push(jsPAL.cmdBar.actionSendBackToDispatcher);
		}
		return actions;
	};
	/**
	 * Set command bar actions for case view tabs (not grid tabs)
	 * @param tabDiv The tab div to search beneath
	 * @param selectedTabIndex The index into the tab array for the selected tab
	 */
	this.setActionsForCaseTabView = function (tabDiv, selectedTabIndex)
	{
		// get the div for the tab
		var div = jsPAL.getTabPanelDiv(tabDiv, selectedTabIndex);
		if (div.attr('tablename') === 'case')
		{
			var caseId = div.attr('primarykey');
			if (caseId != '')
			{
				this.putCaseId(caseId);
				var actions = Array();
				if (AlreadyOpenedCases)
				{
					if (AlreadyOpenedCases[caseId])
					{
						// do not set actions for prior cases
						if (jsPAL.isPriorCaseTab(tabDiv, selectedTabIndex) === false)
						{
							actions = this.getActionArray(AlreadyOpenedCases[caseId]);
						}
						this.setActions(actions, AlreadyOpenedCases[caseId].assignedUserFullName);
					}
				}
			}
		}
	};
	/**
	 * Set the actions for items inside of case grids
	 * @param caseId The case id
	 */
	this.setActionsForCaseGrid = function (caseId)
	{
		// get case tab index
		var index = jsPAL.getCaseTabIndex($('#MainTabs'), caseId);
		// don't set actions for prior cases
		if (jsPAL.isPriorCaseTab($('#MainTabs'), index) === false)
		{
			this.putCaseId(caseId);
			// find the jqGrid row for this case id
			var selectedRow = jsPAL.getCaseGridRow(this.caseId);
			if (selectedRow.length > 0)
			{
				var actions = this.getActionArray(selectedRow);
				this.setActions(actions, selectedRow.attr('downtovwcaseinfobycaseid.assignedto'));

				// extend the Actions dropdown with the list of Endpoints to transfer to
				extendActionsList(function(ajaxResponse){
					if (ajaxResponse != null && typeof ajaxResponse !== 'undefined' && typeof ajaxResponse.value == 'object' && ajaxResponse.value.length > 0) {
						Object.keys(ajaxResponse.value).map(function(key) {
							var endpoint = ajaxResponse.value[key];
							if(typeof endpoint.Id == 'number' && typeof endpoint.Name == 'string')
							{
								var select = $('#commandBarActions');
								select.append("<option endpointId='" + parseInt(endpoint.Id) + "' value='' >Transfer to " + endpoint.Name + "</option>");
							}
						});
					}
				});
			}
		}
	};

	/**
	 * Set the actions for selected case grid row
	 */
	this.setActionsForSelectedCaseGridRow = function(grid)
	{
		if (undefined !== grid && grid.length > 0)
		{
			var caseId = grid.jqGrid('getGridParam', 'selrow');
			if (null !== caseId && undefined !== caseId)
			{
				this.setActionsForCaseGrid(caseId);
			}
			else
			{
				this.clearActions();
			}
		}
	}
	/**
	 * Clear the current action
	 */	
	this.clearCurrentAction = function()
	{
		this.currentCommandAction = -1;
	};
	/**
	* Clean up after command complete
	*/
	this.commandComplete = function(closeCase)
	{
		jsPAL.updateBadgeData();
		if (true == closeCase)
		{
			jsPAL.closeCaseTab($('#MainTabs'), jsPAL.cmdBar.caseId);
			jsPAL.cmdBar.caseId = 0;
		}
		jsPAL.cmdBar.clearActions();
		jsPAL.cmdBar.assignCaseInfo = {};
		jsPAL.refreshJQGrids();
	};
	/*
	* cancelSave() - don't allow SaveAll due to user input errors
	*/
	this.cancelSave = function()
	{
		jsPAL.cmdBar.inputsAreValid = false;
	}
	/**
	 * Create a generic Memo Prompt modal window
	 *@param dialogId The modal dialog id
	 *@param dataUri The data URI send to AjaxDatabaseRead.php
	 *@param notificationTxt The Text displayed in the notification window
	 *@param errorMsg The text to alert during error
	 *@param displayPreviousMemos If true, places the memo history into the dialog box, else is is created empty
	 */
	this.loadGenericMemoPromptDialog = function(dialogId, dataUri, notificationTxt, errorMsg, displayPreviousMemos)
	{
		var dlg = $(dialogId);
		// get the memo field from the case and put it in the dialog
		jsPAL.displayNotification(notificationTxt, 0);
		$.ajax(
		{
			type : "POST",
			url : "/AJAXDatabaseRead.php",
			data: dataUri,
			success : function(msg)
			{
				var jsonData = ParseJson(msg);
				if (undefined !== jsonData.Alert)
				{
					jsPAL.closeNotification();
					if (jsonData.Alert.indexOf(-7014) > -1)
					{
						alert('Unable to request additional work - a database error has occurred.');
					}
					else
					{
						alert(jsonData.Alert);
					}
					return;
				}
				// load the memo data (if any) into the dialog
				if (undefined !== jsonData[0]['DownToCaseNoteByCaseId.NoteText'])
				{
					var memo = jsonData[0]['DownToCaseNoteByCaseId.NoteText'];
					if (memo.length > 0)
					{
						memo += '\n';
					}
					if (true === displayPreviousMemos)
					{
						dlg.find(':input.caseNote').first().val(memo);
					}
					else
					{
						dlg.find(':input.caseNote').first().val("");
					}
				}
				dlg.dialog('open');
				jsPAL.dynamicHtmlModalLayout(dialogId);
			},
			error : function(jqXHR, textStatus, errorThrown)
			{
				alert(errorMsg  + " " + errorThrown);
			}
		});
	};
	
	/**
	 * Create a Generic Send Back to Dialog for various workflows
	 * The following parameters are automatically added to the requestUrl as parameters
	 *   caseid - The id of the case
	 *   memocontent - The memo text
	 *   consultrequestid - The current consultation request id [if present]
	 *   workflowname - The current workflowname
	 * @param dialogId The dialog id
	 * @param dialogTitle The title of the dialog
	 * @param requestUrl The page to send the request
	 * @param notificationWaitMsg Notification Message before sending request
	 * @param notificationCompleteMsg Notification Message after completing request
	 * @param errorMsg String to alert on error condition
	 **/
	this.createGenericMemoPromptWorkDlg = function(dialogId, dialogTitle, requestUrl, notificationWaitMsg, notificationCompleteMsg, errorMsg)
	{
		if ($(dialogId).find().length === 0)
		{
			$(dialogId).dialog(
			{
				autoOpen : false,
				title: dialogTitle,
				modal : true,
				resizable : false,
				width : 400,
				closeOnEscape : false,
				open : function(event, ui)
				{
					$(".ui-dialog-titlebar-close").hide();
					$(dialogId).find(':input.caseNote').first().focus();
				},
				buttons :
				{
					"Send" : function()
					{
						jsPAL.displayNotification(notificationWaitMsg);
						var caseId = jsPAL.cmdBar.getCaseId();
						var consultationRequestId = jsPAL.cmdBar.getConsultationRequestId();
						var consultRequestParam = "";
						if (consultationRequestId)
						{
							consultRequestParam = "&consultrequestid=" + consultationRequestId;
						}
						var workflowName = jsPAL.getPALModuleName();

						$.ajax(
						{
							type : "POST",
							url : requestUrl,
							data: "caseid=" + caseId + "&memocontent=" + encodeURIComponent( $(dialogId).find(':input.caseNote').first().val()) + "&workflowname="+ workflowName + consultRequestParam,
							success : function(msg)
							{
								var jsonData = ParseJson(msg);
								// Clear the previous memo?
								$(dialogId).find(':input.CaseNote').first().val("");
								if (false === jsPAL.checkDataServerResultForError(jsonData))
								{
									jsPAL.cmdBar.commandComplete(true);
									jsPAL.displayNotification(notificationCompleteMsg);
									if (typeof addNewCaseTab === 'function')
									{
										addNewCaseTab($('#MainTabs'));
									}
								}
								else
								{
									if (jsonData.hasOwnProperty('ASMessage'))
									{
										alert(CleanUpDSErrorMessage(jsonData.ASMessage));
									}
									else
									{
										var parsedJsonMessage = $.parseJSON(jsonData).ASMessage;
										if (parsedJsonMessage )
										{
											alert(CleanUpDSErrorMessage(parsedJsonMessage));
										}
									}
								}
							},
							error : function(jqXHR, textStatus, errorThrown)
							{
								alert(errorMsg + " " + errorThrown);
								jsPAL.updateBadgeData();
								jsPAL.refreshJQGrids();
							}
						});
						$(this).dialog("close");

					},
					Cancel : function()
					{
						jsPAL.closeNotification();
						$(this).dialog("close");
					}
				}
			});
		}
	};

	/**
	* Create an upload case request dialog box
	*/
	this.createUploadCaseRequestDlg = function (uploadMode)
	{
		var dialogId = "#uploadCaseRequestDlg";
		var dialogTitle = "eCase " + this.capitaliseFirstLetter(uploadMode) + " Request";
		var notificationWaitMsg = "Scheduling eCase for " + uploadMode + ". Please wait...";
		var notificationCompleteMsg = "eCase scheduled for " + uploadMode;
		var errorMsg = "Error scheduling eCase for " + uploadMode + ": ";
		var requestUrl = "/PALModules/HealthCare/UploadCase.php";
		jsPAL.cmdBar.createGenericMemoPromptWorkDlg(dialogId, dialogTitle, requestUrl, notificationWaitMsg, notificationCompleteMsg, errorMsg);
	};
	this.capitaliseFirstLetter = function (string)
	{
		return string.charAt(0).toUpperCase() + string.slice(1);
	}  

	// get a list of endpoints from the DB
	function extendActionsList(result)
	{
		$.ajax(
		{
			type : "POST",
			url : "/PALModules/HealthCare/CaseAssembly/TSEndpoints.php",
			success : result
		});
	}

	// display error message on UI when an error occurs for initiating a transfer in Transfer Service
	function transferServicesErrorMessage(errorText)
	{
		alert("Error submitting case: " + errorText);
		jsPAL.updateBadgeData();
		jsPAL.refreshJQGrids();
	}
};
